/* eslint-disable no-unused-vars */

import { Dispatch, SetStateAction, useState } from 'react';

import { CaptionText, H4, P1, P2, P3 } from '../../styles/FontStyles';

import { Flexed } from '../../styles/GlobalComponents';
import { color, lightTheme } from '../../styles/GlobalStyles';
import { BoxBig, HubImage, Td, Tr } from './Portfolio.styled';

import moment from 'moment';

//GAMING
import fortunePanda from '../../assets/images/backoffice/gamingImages/fortunePanda.jpg';
import luckyApe from '../../assets/images/backoffice/gamingImages/luckyApe.jpg';
import magicUnicorn from '../../assets/images/backoffice/gamingImages/magicUnicorn.jpg';
import mightyDragon from '../../assets/images/backoffice/gamingImages/mightyDragon.jpg';
import mysticLion from '../../assets/images/backoffice/gamingImages/mysticLion.jpg';
import ragingBull from '../../assets/images/backoffice/gamingImages/ragingBull.jpg';
import risingPhoenix from '../../assets/images/backoffice/gamingImages/risingPhoenix.jpg';
import wealthyTiger from '../../assets/images/backoffice/gamingImages/wealthyTiger.jpg';
import wiseElephant from '../../assets/images/backoffice/gamingImages/wiseElephant.jpg';

//PAYMENT
import crystalSkyscraper from '../../assets/images/backoffice/paymentImages/crystalSkyscraper.png';
import dreamCastle from '../../assets/images/backoffice/paymentImages/dreamCastle.png';
import luxuryVilla from '../../assets/images/backoffice/paymentImages/luxuryVilla.png';
import modernApartment from '../../assets/images/backoffice/paymentImages/modernApartment.png';
import paradiseIsland from '../../assets/images/backoffice/paymentImages/paradiseIsland.png';
import plazaHotel from '../../assets/images/backoffice/paymentImages/plazaHotel.png';
import royalMansion from '../../assets/images/backoffice/paymentImages/royalMansion.png';
import skylinePenthouse from '../../assets/images/backoffice/paymentImages/skylinePenthouse.png';
import tropicalBeachHouse from '../../assets/images/backoffice/paymentImages/tropicalBeachHouse.png';

import {
  LP,
  formatUSD,
  formatUSDNoDecimals
} from '../../helpers/helperFunctions';
import { Responsive } from '../../styles/stylesStyled';

import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Button } from '../../components';
import Spinner from '../../components/common/Spinner';
import {
  setConversionUserPackageId,
  toggleConversionModal
} from '../../slices/portfolio-slice';
import { UserPackage } from './Portfolio.types';
import { PortfolioItemDisabled } from './PortfolioItemDisabled';

import { WithdrawHubs } from './WithdrawHubs/WithdrawHubs';
import { WithdrawStepsEnum } from './WithdrawHubs/types';

interface PortfolioGamingProps {
  setWithdrawStep: Dispatch<SetStateAction<WithdrawStepsEnum>>;
  withdrawStep: WithdrawStepsEnum;
  item: UserPackage;
}

export const PortfolioGamingItem = ({
  item,
  withdrawStep,
  setWithdrawStep
}: PortfolioGamingProps) => {
  const [openModal, setOpenModal] = useState(false);
  const [packageId, setPackageId] = useState<number>(1);

  const dispatch = useAppDispatch();

  const { t } = useTranslation('my_hubs');

  const showDisabledGamingHub = (item: any) => {
    if (item?.dateNftWidthdrawal) {
      const dateNow = moment(new Date());
      const fromNow = moment.duration(dateNow.diff(item?.claimDate));
      const days = fromNow.days();
      const hours = fromNow.hours();

      if (days === 0 && hours < 24) {
        return (
          <PortfolioItemDisabled
            title={t('disabled_hub_title')}
            subtitle='It may take up to 24 Hours for Hub NFT to Refresh.'
          />
        );
      }
    }
  };

  const showConvertedHub = (item: any) => {
    if (item?.dateConverted) {
      return (
        <PortfolioItemDisabled
          title={'You Have Converted this Hub NFT into Loyalty Points'}
          subtitle={
            <>
              Date of conversion:{' '}
              {moment.utc(item?.dateConverted).format('MMM DD, yyyy')} <br />{' '}
              Loyalty Points Received: {formatUSD(item?.loyaltyPoints)} {LP}
            </>
          }
        />
      );
    }
  };

  const showDetailsText = (id: number) => {
    if (id < 50) {
      return t('gaming_hub_details');
    } else if (id >= 50 && id < 180) {
      return t('payment_hub_details');
    } else if (id >= 180 && id < 204) {
      return 'FlipMe card details';
    }
  };

  return (
    <>
      <BoxBig relative>
        <HubImage image={item?.image}>
          <H4 color={color.colors.neutral0}>{item?.name}</H4>
        </HubImage>
        <div>
          <div
            style={{
              position: 'absolute',
              left: '50%',
              right: '50%',
              transform: 'translate(-50%, -50%)'
            }}>
            <Spinner />
          </div>
          <Flexed>
            <>
              <Tr style={{ cursor: 'pointer' }}>
                <Td w='20%' wSM='50%'>
                  <CaptionText
                    caps
                    bold
                    color={color.colors.neutral500}
                    mb='10'>
                    {t('price')}
                  </CaptionText>
                  <P1 bold flex alignEnd gap='5px'>
                    {formatUSDNoDecimals(item?.price)} <P3 mb='1'>USDT</P3>
                  </P1>
                </Td>

                <Td w='20%' wSM='50%'>
                  <CaptionText
                    caps
                    bold
                    color={color.colors.neutral500}
                    mb='10'>
                    {t('date_of_purchase')}
                  </CaptionText>
                  <P1 bold>
                    {moment(item?.dateOfPurchase).format('DD MMM YYYY')}
                  </P1>
                </Td>
                <Td w='20%' wSM='50%'>
                  <CaptionText
                    caps
                    bold
                    color={color.colors.neutral500}
                    mb='10'>
                    {item.packageId < 180
                      ? t('revenue_share_points')
                      : 'Activation code'}
                  </CaptionText>
                  {item.packageId < 180 ? (
                    <P1 bold flex alignEnd gap='5px'>
                      {formatUSD(item?.rsp)} <P3 mb='1'>RSP</P3>
                    </P1>
                  ) : (
                    <P1 bold flex alignEnd gap='5px'>
                      COMING SOON
                    </P1>
                  )}
                </Td>
              </Tr>
            </>
            <>
              {/* {item?.isWithdrawable && (
                <Icon
                  onClick={() => {
                    setOpenModal(!openModal);
                    setPackageId(item?.id);
                    disconnect();
                    if (kycStatus.isKycCompleted) {
                      setWithdrawStep(WithdrawStepsEnum.INIT);
                    } else {
                      setWithdrawStep(WithdrawStepsEnum.NO_KYC);
                    }
                  }}
                  style={{ cursor: 'pointer' }}>
                  <IconWithdrawHubs />
                </Icon>
              )} */}
            </>
          </Flexed>
          <div>
            <>
              <Responsive style={{ margin: '24px 0' }} between>
                <Flexed mbSM='20' rowSM gap='20px'>
                  <P3 caps bold color={color.colors.secondary100}>
                    {showDetailsText(item?.packageId)}
                  </P3>
                  <P3 flex color={color.colors.secondary100}>
                    {t('order_id')}:{' '}
                    <P3 bold color={color.colors.secondary100}>
                      {item?.id}
                    </P3>
                  </P3>

                  <P3 flex color={color.colors.secondary100}>
                    {item?.packageId < 180 ? t('nft_id') : 'PACKAGE ID'}:
                    <P3 bold color={color.colors.secondary100}>
                      {item.packageId < 180 ? item?.nftId : item?.packageId}
                    </P3>
                  </P3>
                </Flexed>
              </Responsive>
            </>
          </div>
          {item?.isConvertable && (
            <div>
              <P2 mt='20'>
                Potential Loyalty Points:{' '}
                <b>
                  {formatUSD(item?.potentialLoyaltyPoints)} {LP}
                </b>
              </P2>
              <Button
                mt='10'
                w='250px'
                negative
                textColor={lightTheme.colors.primary900}
                onClick={() => {
                  dispatch(toggleConversionModal(true));
                  dispatch(setConversionUserPackageId(item.id));
                }}>
                CONVERT TO LOYALTY POINTS
              </Button>
            </div>
          )}
        </div>
        {showDisabledGamingHub(item)}
        {showConvertedHub(item)}
      </BoxBig>

      <WithdrawHubs
        openModal={openModal}
        setOpenModal={setOpenModal}
        packageId={packageId}
        withdrawStep={withdrawStep}
        setWithdrawStep={setWithdrawStep}
      />
    </>
  );
};
